import {appAPI} from "../../../api";
import {IFuelPrice} from "../../../models/IFuelPrice";

const basePath = `/fuel_price`;

export const fuelPriceAPI = {
    /** Текущие цены всех 4 видов топлива компании (company_id из JWT). */
    getPrices: async (): Promise<IFuelPrice[]> => {
        const res = await appAPI.get(basePath);
        return res.data;
    },

    /** Задать цену одного вида топлива. effective_from опционален (бэк = сегодня по МСК). */
    setPrice: async (
        fuel_type: string,
        price_per_liter: number,
        effective_from?: string,
    ): Promise<IFuelPrice> => {
        const res = await appAPI.post(basePath, {
            fuel_type,
            price_per_liter,
            effective_from,
        });
        return res.data;
    },
};
